import { render, staticRenderFns } from "./gz.vue?vue&type=template&id=2ab353c6&scoped=true"
import script from "./gz.vue?vue&type=script&lang=js"
export * from "./gz.vue?vue&type=script&lang=js"
import style0 from "./gz.vue?vue&type=style&index=0&id=2ab353c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab353c6",
  null
  
)

export default component.exports